import { Component, ContentChild, ElementRef, HostListener, Inject, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { cdkOverlayRef } from 'src/app/shared/custom-overlay/cdk-overlay-ref';
import { ErrorMsgHandler } from 'src/app/shared/errormanagement/handleerror';
import { TagAutocompleteDirective } from 'src/app/shared/tagautocomplete/tag-autocomplete.directive';
import { TagOptionComponent } from 'src/app/shared/tagautocomplete/tagoption/tag-option.component';
import { TagOptionGroupComponent } from 'src/app/shared/tagautocomplete/tagoptiongroup/tag-option-group.component';
import { AlertsService } from '../../alerts-custom.service';
import { StructureTagService } from 'src/app/services/structureTag.service';
import { CdkOverlyayService } from 'src/app/shared/custom-overlay/cdk-overlyay.service';
import { AssetDropdownService } from 'src/app/shared/assets/assets-dropdown.service';
import { distinctUntilChanged, startWith, takeUntil } from 'rxjs/operators';
import { AssetsComponent } from 'src/app/shared/assets/assets.component';
import { DOCUMENT, KeyValue } from '@angular/common';
import { TemplateDropdownComponent } from 'src/app/shared/custom-overlay/template-dropdown/template-dropdown.component';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { Router } from '@angular/router';
import { UserOptions } from 'jspdf-autotable';
import * as moment from 'moment-timezone';
import { AlertsvarService, FactsheetEventsPanel, FactsheetSummaryPanel } from '../../alertsvar.service';
import { TimeZoneService } from 'src/app/services/time-zone.service';
import { ForceContinueComponent } from '../../template/force-continue/force-continue.component';
import { SharedService } from 'src/app/services/shared.service';
import { AuthService } from 'src/app/auth/auth.service';
import { options } from 'knockout';
import { Metropolis_ExtraLight, Metropolis_Light,Metropolis_LightItalic,Metropolis_Medium,Metropolis_Regular,Metropolis_SemiBold} from 'src/assets/fonts/font';
import { DeDupComponent } from '../../de-dup/de-dup.component';



interface jsPDFWithPlugin extends jsPDF {
  autoTable: (options: UserOptions) => jsPDF;
}

@Component({
  selector: 'app-summary-table',
  templateUrl: './summary-table.component.html',
  styleUrls: ['./summary-table.component.scss']
})
export class SummaryTableComponent {

  // @ViewChild('chipList') chipList!: ElementRef;

@ViewChildren('chipElement')
chipElements!: QueryList<ElementRef>;

@ViewChild('chipMeasure')
chipMeasure!: ElementRef;

@ViewChild('deduppop') deduppop: TemplateRef<any>;

visibleChips: any[] = [];
morechipslist: any[] = [];
  
  fullScreenElement: any; //to hold the html document for fullscreen 
  fullscreenState: boolean = false;
  alertFilterState: boolean = true;
  alertMetaData: any = JSON.parse(JSON.stringify(this.sharedService.metaData.alert)); //holds alert meta data

  $destroy: Subject<boolean> = new Subject();

  dialogRef

  overLayRef: cdkOverlayRef;
  createrule: cdkOverlayRef;
  limitCount = 100;
  // no_of_alerts:number

  alertFilter: any = { "filters": {}, "informations": {} }

//   mockFilter={
//     "filters": {
//         "time": {
//             "values": [
//                 {
//                     "disp": "Last 1 Hour",
//                     "value": [
//                         -1,
//                         "hour",
//                         1
//                     ],
//                     "count": null
//                 },
//                 {
//                     "disp": "Last 3 Hour",
//                     "value": [
//                         -1,
//                         "hour",
//                         3
//                     ],
//                     "count": null
//                 },
//                 {
//                     "disp": "Today",
//                     "value": [
//                         0,
//                         "today",
//                         0
//                     ],
//                     "count": null
//                 },
//                 {
//                     "disp": "Yesterday",
//                     "value": [
//                         -1,
//                         "yesterday",
//                         1
//                     ],
//                     "count": null
//                 },
//                 {
//                     "disp": "last 7 Days",
//                     "value": [
//                         -1,
//                         "day",
//                         6
//                     ],
//                     "count": null
//                 },
//                 {
//                     "disp": "Last 30 Days",
//                     "value": [
//                         -1,
//                         "day",
//                         29
//                     ],
//                     "count": null
//                 },
//                 {
//                     "disp": "Last 90 Days",
//                     "value": [
//                         -1,
//                         "day",
//                         89
//                     ],
//                     "count": null
//                 },
//                 {
//                     "disp": "Last 120 Days",
//                     "value": [
//                         -1,
//                         "day",
//                         119
//                     ],
//                     "count": null
//                 },
//                 {
//                     "disp": "Last 180 Days",
//                     "value": [
//                         -1,
//                         "day",
//                         179
//                     ],
//                     "count": null
//                 },
//                 {
//                     "disp": "Last 300 Days",
//                     "value": [
//                         -1,
//                         "day",
//                         299
//                     ],
//                     "count": null
//                 }
//             ],
//             "multi_select": false,
//             "mandatory": true
//         },
//         "platform": {
//             "values": [
//                 {
//                     "disp": "Fortigate Firewall",
//                     "value": "firewall_fortigate",
//                     "count": 422259
//                 },
//                 {
//                     "disp": "Palo Alto Firewall",
//                     "value": "firewall_paloalto",
//                     "count": 0
//                 },
//                 {
//                     "disp": "Cisco Firewall",
//                     "value": "firewall_cisco",
//                     "count": 0
//                 },
//                 {
//                     "disp": "Cisco Router",
//                     "value": "router_cisco",
//                     "count": 0
//                 },
//                 {
//                     "disp": "Cisco Switch",
//                     "value": "switch_cisco",
//                     "count": 0
//                 },
//                 {
//                     "disp": "Windows",
//                     "value": "windows",
//                     "count": 0
//                 },
//                 {
//                     "disp": "Firepower",
//                     "value": "ftd_cisco",
//                     "count": 0
//                 }
//             ],
//             "multi_select": false,
//             "mandatory": true
//         },
//         "severity": {
//             "values": [
//                 {
//                     "disp": "Medium",
//                     "value": "medium",
//                     "count": 332864
//                 },
//                 {
//                     "disp": "Low",
//                     "value": "low",
//                     "count": 89083
//                 },
//                 {
//                     "disp": "Info",
//                     "value": "informational",
//                     "count": 280
//                 },
//                 {
//                     "disp": "High",
//                     "value": "high",
//                     "count": 40
//                 }
//             ],
//             "multi_select": true,
//             "mandatory": false
//         },
//         "title": {
//             "values": [
//                 {
//                     "disp": "Newly Observed Port Use",
//                     "value": "FWFGT.0008.04",
//                     "count": 245494
//                 },
//                 {
//                     "disp": "Outbound Network Connection to High-Risk Countries",
//                     "value": "FWFGT.0009.03",
//                     "count": 86147
//                 },
//                 {
//                     "disp": "Outbound traffic to high risk countries retro",
//                     "value": "FWFGT.0023.01",
//                     "count": 86147
//                 },
//                 {
//                     "disp": "TI Match - Inbound",
//                     "value": "FWFGT.0014.05",
//                     "count": 2862
//                 },
//                 {
//                     "disp": "External Port Scanning",
//                     "value": "FWFGT.0022.03",
//                     "count": 665
//                 },
//                 {
//                     "disp": "Outbound Traffic from Internal IPs on Nonstandard Ports",
//                     "value": "FWFGT.0012.07",
//                     "count": 558
//                 },
//                 {
//                     "disp": "Internal IPs contacts many external IPs in a short window. /Destination IP count threshold exceeded ",
//                     "value": "FWFGT.0016.02",
//                     "count": 195
//                 },
//                 {
//                     "disp": "Destination IPs with the greatest number of dropped sessions",
//                     "value": "FWFGT.0021.01",
//                     "count": 71
//                 },
//                 {
//                     "disp": "test_aggreeruleverification",
//                     "value": "FWFGT.0034.02",
//                     "count": 55
//                 },
//                 {
//                     "disp": "TI Match - Outbound",
//                     "value": "FWFGT.0015.03",
//                     "count": 30
//                 },
//                 {
//                     "disp": "test_systaxcheck",
//                     "value": "FWFGT.0035.01",
//                     "count": 14
//                 },
//                 {
//                     "disp": "Detect Outbound LDAP Traffic",
//                     "value": "FWFGT.0003.05",
//                     "count": 10
//                 },
//                 {
//                     "disp": "test_checkingcommunicationsection",
//                     "value": "FWFGT.0033.01",
//                     "count": 10
//                 },
//                 {
//                     "disp": "test_denyftptelnet",
//                     "value": "FWFGT.0026.01",
//                     "count": 7
//                 },
//                 {
//                     "disp": "Src_ip-distinct-dest_ip-spike",
//                     "value": "FWFGT.0020.01",
//                     "count": 2
//                 }
//             ],
//             "multi_select": true,
//             "mandatory": false
//         },
//         "data_type": {
//             "values": [
//                 {
//                     "disp": "Common",
//                     "value": "common",
//                     "count": 342299585
//                 },
//                 {
//                     "disp": "Port",
//                     "value": "port",
//                     "count": 955734
//                 },
//                 {
//                     "disp": "IP",
//                     "value": "ip",
//                     "count": 918282
//                 }
//             ],
//             "multi_select": true,
//             "mandatory": false
//         },
//         "observable": {
//           "values": [],
//             "multi_select": true,
//             "mandatory": false
//         },
//         "signature": {
//             "values": [],
//             "multi_select": true,
//             "mandatory": false
//         },
//         "tags": {
//             "values": [],
//             "multi_select": true,
//             "mandatory": false
//         }
//     },
//     "informations": {
//         "status": {
//             "values": [
//                 {
//                     "disp": "New",
//                     "count": 419397,
//                     "value": 0
//                 },
//                 {
//                     "disp": "Close",
//                     "count": 2862,
//                     "value": 2
//                 }
//             ],
//             "multi_select": true,
//             "mandatory": false
//         }
//     }
// }



  post_severity = []
  post_status = []
  post_title = []
  post_dataType = []
  post_observable = []
  post_compliance = []
  post_signature = []
  post_tags = {
    "killchain": [],
    "compliance": [],
    "mitreattack": [],
    "threatgroup": []
  }

  //   chips:{ [key: string]: any }[] = [
  //     {
  //         "time": {
  //             "disp": "Last 24 Hour",
  //             "value": [
  //                 -1,
  //                 "hour",
  //                 24
  //             ],
  //             "count": null,
  //             "mandatory":true
  //         }
  //     },
  //     {
  //         "platform": {
  //             "disp": "Firewall Fortigate",
  //             "value": "firewall_fortigate",
  //             "count": 10298,
  //             "mandatory":true
  //         }
  //     }
  // ];
  morechips: any
  mockData: any
  payload: any = {
    "timerange": [],
    "platform": "firewall_fortigate",
    "tags": {
      "killchain": [],
      "compliance": [],
      "mitreattack": [],
      "threatgroup": []
    },
    "severity": [],
    "status": [],
    "title": [],
    "data_type": [],
    "observable": [],
    "signature": []
  }

  @ContentChild(TagAutocompleteDirective) tagdirective: TagAutocompleteDirective;
  @ViewChildren(TagOptionComponent, { read: ElementRef }) optionsList: QueryList<ElementRef>;
  @ViewChildren(TagOptionGroupComponent) optionsGroup: QueryList<ElementRef>;
  @ViewChild('chipList') chipList: ElementRef<HTMLElement>;

  //pagination count
  //pagesLength: number = 1;
  spinner_alert_list_state: boolean = true;
  spinner_alert_filter_state: boolean = false;
  inProgress: boolean = true;

  selectedTags: number = 0;

  filterSize: number

  @ViewChild('overlayOrigin', { static: true }) overlayOrigin: ElementRef;

  handleprovidealertdataerror = new ErrorMsgHandler();
  //to monitor the fullscreen mode with different browser support
  @HostListener('document:fullscreenchange', ['$event'])
  @HostListener('document:webkitfullscreenchange', ['$event'])
  @HostListener('document:mozfullscreenchange', ['$event'])
  @HostListener('document:MSFullscreenChange', ['$event'])
  fullScreenChange() {
    this.fullscreenState = !this.fullscreenState;
  }



  constructor
    (
      @Inject(DOCUMENT) private document: any,
      public matdialog: MatDialog,
      private router: Router,
      private cdkverlayDialog: CdkOverlyayService,
      public alertservice: AlertsService,
      private structureTagsService: StructureTagService,
      private sharedService: SharedService,
      private cdkoverlayDialog: CdkOverlyayService,
      private assetsService: AssetDropdownService,
      public alertvarservice: AlertsvarService,
      private timezoneservice: TimeZoneService,
      private authService: AuthService
    ) { }
  force_view: boolean = false;

  async ngOnInit() {
    this.alertvarservice.payload.timerange = this.toDate(this.alertvarservice.chips[0].time.value);

    //console.log("chips---->",this.alertvarservice.chips)
    this.alertvarservice.getAlertData().subscribe(data => {
      this.mockData = data;

    });
    // this.authService.logout().subscribe(()=>{

    // })
    this.sharedService.$userLoggedoff.subscribe(val => {
      //  console.log("Log off")
      this.resetChip()


    })

    //Set Alert Filters
    // this.alertservice.getAlertFilter(this.alertvarservice.payload).subscribe((val) => {
    //   console.log("Filter Data",val)
    //   this.alertFilter=val
    //   this.filterSize=Object.keys(this.alertFilter.informations).length
    // })

    setTimeout(() => {
      // this.spinner_alert_list_state = true;
      this.applyFilter_click()
      //  this.spinner_alert_list_state = false;
    }, 0);


    // this.alertFilter=this.alertservice.getAlertFilter()
    // this.filterSize=Object.keys(this.alertFilter.informations).length

    // console.log(this.alertFilter.tags.values)
    this.fullScreenElement = document.documentElement;
    this.alertservice.providealertdata.isProgress$.subscribe((val) => {
      if (val) {
        this.alertvarservice.tagsSearchcontrol.disable({ emitEvent: false });
        this.alertvarservice.alertFilters.disable({ emitEvent: false });
      } else {
        this.alertvarservice.tagsSearchcontrol.enable({ emitEvent: false });
        this.alertvarservice.alertFilters.enable({ emitEvent: false });
      }
      this.spinner_alert_list_state = val;
      this.inProgress = val;
    })

    this.assetsService._savedAssets.pipe(takeUntil(this.$destroy))
      .subscribe((assets) => {
        if (assets.platform !== this.platform.value) {
          this.platform.setValue(assets.platform, { emitEvent: false });
        }
        delete assets['platform'];
        delete assets['platformfields'];
        delete assets['dispPlatform'];
        this.impactedHost.setValue(assets);
      })

    this.external.valueChanges.subscribe(val => {
      this.alertvarservice.filter_changes_state = true;
    })

    this.alertvarservice.tagsSearchcontrol.valueChanges.pipe(distinctUntilChanged()).subscribe((val: string) => {
      this.alertvarservice.tagsMapping(this.alertvarservice.commondata.tags.mapping)
      this.alertvarservice.tagsSearch(val)
    })

    this.tags.valueChanges.pipe(startWith(this.tags.value)).subscribe(val => {
      this.selectedTags = this.structureTagsService.createsetsforalert(val, this.alertvarservice.tagmapping).size;
    })

    this.itemPerPage.valueChanges.pipe(distinctUntilChanged()).subscribe((dat) => {
      this.handlePagination(this.alertvarservice.alertRows.length, this.itemPerPage.value)
    })

    if (this.alertservice.providealertdata.emitstate) {
      await this.requestAlertonInit();
    } else {
      if (!this.alertservice.providealertdata.responsestate) {
        await this.requestAlertonInit();
      } else {
        this.alertservice.providealertdata.emitstate = 1;
      }
    }
  }

  ngAfterViewInit() {
    this.calculateChips()

    this.visibleChips = this.alertvarservice.chips

    this.sharedService.$userLoggedoff.pipe(distinctUntilChanged()).subscribe(data => {
      if (data) {
//console.log({ data })
        this.alertservice.alertsummarycomponentDestroyed.next(0);
        this.clearFilter()
      }
    })
  }




  async requestAlertonInit() {
    const postValue: any = this.alertvarservice.alertFilters.getRawValue();
    // postValue.external = this.toDate(this.alertvarservice.chips[0].time.value);
    postValue.external.timerange = this.toDate(this.alertvarservice.chips[0].time.value);
    postValue.external.platform = this.alertvarservice.chips[1].platform.value
    this.alertvarservice.advanced_filter_values = this.alertvarservice.get_events_timerange()
    postValue.external.tags = this.structureTagsService.structureTagPost(postValue.external.tags);
    await this.requestAlertSummarydata(this.processFilterPost(postValue));

  }

  provideInternalFilter(alertRows: any[], filterval: any) {
    this.alertvarservice.alertRows.length = 0
    alertRows.forEach((alert: any) => {
      // this.alertvarservice.alertRows.push(alert)
      // console.log("before if",this.alertvarservice.alertRows)
      if (this.validatefilterval(alert.alertCount, alert.alertPercentage, filterval)) {
        this.alertvarservice.alertRows.push(alert)
        // console.log("inside if",this.alertvarservice.alertRows)
      }
    })
  }

  validFilter = {
    greater: {
      handle(compare: number, comparedto: number) {
        return compare > comparedto
      }
    },
    lesser: {
      handle(compare: number, comparedto: number) {
        return compare < comparedto
      }
    }
  }

  validatefilterval(count: number, percentage: number, filterval: any) {
    const countvalid = this.validFilter[filterval.alertcount[0]].handle(count, filterval.alertcount[1]);
    const percentValid = this.validFilter[filterval.alertpercentage[0]].handle(percentage, filterval.alertpercentage[1]);
    return (countvalid && percentValid);
  }

  calculateSummary(alertrows: any[], totalcount: number) {
    alertrows.forEach((alert: any) => {
      let percentval = (alert.alertCount * 100) / totalcount;
      alert.alertPercentage = ((percentval <= 0.01) ? 0.01 : parseFloat(percentval.toFixed(2)))

    })
  }

  sortTable(alertrows: any[]) {
    alertrows.sort((a: any, b: any) => {
      if (new Date(a.lastAlertTime * 1000) > new Date(b.lastAlertTime * 1000)) {
        return -1
      } else if (new Date(a.lastAlertTime * 1000) < new Date(b.lastAlertTime * 1000)) {
        return 1
      } else {
        return 0
      }
    });
  }

  resetChip() {
    // Object.keys(this.alertvarservice.chips).forEach(key=>{
    //   this.removeChip(this.alertvarservice.chips[key])
    // })
    this.alertvarservice.chips = this.alertvarservice.defaultChips
  }

  cleartagvalue() {
    if (!this.inProgress) {
      this.tags.reset();
    }
  }

  processFilterPost(val: any) {
    let postval = { ...val, ...val.internal, ...val.external }
    delete postval.internal;
    delete postval.external;
    return postval
  }

  openAssetsDropdown_click(origin) {
    if (!this.inProgress) {
      //console.log(this.impactedHost.value, this.platform.value)
      this.openOverlay(origin, AssetsComponent,
        [
          { ...this.impactedHost.value, platform: this.platform.value },
          { disable: false, customHost: true }
        ], ["auto", "81vw"]);
    }
  }

  openDedup(origin,alertId,status) {
    // this.openResize(
    //   origin,
    //   DeDupComponent,
    //   [
    //     {}
    //   ],
    //   ["50vh", "50vw","flex"]
    // );

    this.openEditPopup(this.deduppop,alertId,status)
  }

  openResize(origin: any, component, componentInputs, dimensions) {
    this.overLayRef = this.cdkoverlayDialog.openResize(
      {
        data: componentInputs,
        height: dimensions[0],
        width: dimensions[1],
      },
      origin,
      component
    );
  
    return this.overLayRef;
  }

  openOverlay(origin: any, component, componentInputs, dimensions) {
    this.overLayRef = this.cdkoverlayDialog.open({
      data: componentInputs,
      height: dimensions[0],
      width: dimensions[1],
    },
      origin, component)
    return this.overLayRef;
  }

  handlePagination(count: number, item: number) {
    if (!this.inProgress) {
      if (count) {
        this.alertvarservice.alertpagelength = Math.ceil(count / item);
        if (this.page.value > this.alertvarservice.alertpagelength) {
          this.page.setValue(this.alertvarservice.alertpagelength, { emitEvent: false })
        }
      } else {
        this.alertvarservice.alertpagelength = 1
      }
    }
  }

  async requestAlertSummarydata(dat: any) {
    // console.log("DAT",dat)
    this.alertvarservice.alertSummaryData = null;
    await this.alertservice.providealertdata.postrequest(dat)
      .then((dat: any) => {
        if (dat.alertRows) {
          // dat.alertRows.push({"status":1,"alertId":"FWFGT.1999.01","platform":"firewall_fortigate","severity":"low","alertTitle":"Mock Alert","created_dt":"2026-08-19T13:11:08.501747","auto_closed":0,"auto_invest":0,"human_closed":0,"total_closed":0,"total_signal":0,"alertCount":1,"lastAlertTime":1786404600,"eventCount":1,"fields":[{"disp":"time","cardinality":"Medium"},{"disp":"action","cardinality":"Low"},{"disp":"srcip","cardinality":"High"},{"disp":"dstip","cardinality":"Very high"}]})
          //console.log("alertRows",dat.alertRows)
          this.calculateSummary(dat.alertRows, dat.totalAlertCount);
          this.sortTable(dat.alertRows);
          this.alertvarservice.alertSummaryData = dat;
          this.provideInternalFilter(this.alertvarservice.alertSummaryData.alertRows, this.internal.value);
          this.handlePagination(this.alertvarservice.alertRows.length, this.itemPerPage.value);
        }
        this.inProgress = false;
        this.handleprovidealertdataerror.seterror(false, null);
      })
      .catch(err => {
        //console.log("ERROR",err)
        this.inProgress = false;
        this.alertvarservice.alertpagelength = 1;
        this.handleprovidealertdataerror.seterror(true, err.error?.errmsg);
      })
    //console.log("AlertRowsSummary",this.alertvarservice.alertRows.length)
    //console.log("AlertSummaryData",this.alertvarservice.alertSummaryData)
    this.alertvarservice.no_of_alerts = this.alertvarservice.alertRows.length
  }

  //unsort the key value from the array of objects
  originalOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    return 0;
  }

  //to activate fullscreen
  openFullscreen_Click() {
    if (this.fullScreenElement.requestFullscreen) {
      this.fullScreenElement.requestFullscreen();
    } else if (this.fullScreenElement.mozRequestFullScreen) { /* Firefox */
      this.fullScreenElement.mozRequestFullScreen();
    } else if (this.fullScreenElement.webkitRequestFullscreen) {  /* Chrome, Safari and Opera */
      this.fullScreenElement.webkitRequestFullscreen();
    } else if (this.fullScreenElement.msRequestFullscreen) {  /* IE/Edge */
      this.fullScreenElement.msRequestFullscreen();
    }
  }
  //to deactivate fullscreen
  closeFullscreen_Click() {
    if (this.document.exitFullscreen) {
      this.document.exitFullscreen();
    } else if (this.document.mozCancelFullScreen) { /* Firefox */
      this.document.mozCancelFullScreen();
    } else if (this.document.webkitExitFullscreen) {  /* Chrome, Safari and Opera */
      this.document.webkitExitFullscreen();
    } else if (this.document.msExitFullscreen) {  /* IE/Edge */
      this.document.msExitFullscreen();
    }
  }
  //to change screen mode
  screenMode(fullscreenState) {
    if (fullscreenState) //not in full screen
      this.openFullscreen_Click()
    else //in full screen
      this.closeFullscreen_Click()
  }
  // basic filter open/close
  closeAlertFilter_click() {
    this.alertFilterState = !this.alertFilterState;
  }

  //get formControl
  get external() {
    return this.alertvarservice.alertFilters.get('external') as UntypedFormGroup
  }

  get tags() {
    return this.external.get('tags')
  }

  get severity() {
    return this.external.get('severity')
  }

  get impactedHost() {
    return this.external.get('impactedHost')
  }
  get platform() {
    return this.external.get('platform')
  }

  get timeZone() {
    return this.external.get('timezone')
  }

  get timeRange() {
    return this.external.get('timerange')
  }

  get internal() {
    return this.alertvarservice.alertFilters.get('internal')
  }

  get alertcount() {
    return this.internal.get('alertcount')
  }

  get alertpercentage() {
    return this.internal.get('alertpercentage')
  }
  get page() {
    return this.alertvarservice.alertFilters.get('page')
  }

  get itemPerPage() {
    return this.alertvarservice.alertFilters.get('itemPerPage')
  }

  //managePagination
  paginationTable_click(direction: number) {
    let pagevalue = this.page.value;
    if (direction == -1) {
      if (this.page.value > 1) {
        this.page.setValue(pagevalue - 1);
      }
    } else {
      if (this.page.value < this.alertvarservice.alertpagelength) {
        this.page.setValue(pagevalue + 1);
      }
    }
  }

  //applyFilters for alert
  applyFilter_click() {


    // this.openConsolidation()


    //console.log("Chips After Filter ----->",this.alertvarservice.chips)
    //console.log("TimeData",this.alertMetaData.filterOptions.timeRanges)
    //console.log("SEVERITY",this.alertvarservice.commondata.severityOptions)
    //console.log("TAGS",this.alertvarservice.distag)
    this.inProgress = false
    //console.log("MockData",this.mockData.res_obj.alertRows)
    // console.log("Chips======------>",this.alertvarservice.chips[4])
    this.post_severity = []
    this.post_status = []
    this.post_title = []
    this.post_dataType = []
    this.post_observable = []
    this.post_compliance = []
    this.post_signature = []
    this.post_tags = {
      "killchain": [],
      "compliance": [],
      "mitreattack": [],
      "threatgroup": []
    }
    Object.keys(this.alertvarservice.chips).forEach(key => {
      // console.log(key,this.alertvarservice.chips[key])
      Object.keys(this.alertvarservice.chips[key]).forEach(val => {
        //console.log(val,this.alertvarservice.chips[key][val])
        if (val === "severity") {
          this.post_severity.push(this.alertvarservice.chips[key][val].value)
        }
        if (val === "status") {
          this.post_status.push(this.alertvarservice.chips[key][val].value)
        }
        if (val === "title") {
          this.post_title.push(this.alertvarservice.chips[key][val].value)
        }
        if (val === "data_type") {
          this.post_dataType.push(this.alertvarservice.chips[key][val].value)
        }
        if (val === "observable") {
          this.post_observable.push(this.alertvarservice.chips[key][val].value)
        }
        // if(val==="compliance"){
        //   this.post_compliance.push(this.alertvarservice.chips[key][val].value)
        // }
        if (val === "signature") {
          this.post_signature.push(this.alertvarservice.chips[key][val].value)
        }
        if (val === "tags") {
          // console.log("Post_tags----->",this.alertvarservice.chips[key][val].value)
          this.post_tags[this.alertvarservice.chips[key][val].parent].push(this.alertvarservice.chips[key][val].value)
          //console.log("Tags----->",this.alertvarservice.chips[key][val].value)
        }
      })
      //console.log("post_tags---->",this.post_tags)

    })
    // this.alertvarservice.alertRows=this.mockData.res_obj.alertRows
    if (!this.inProgress) {
      this.page.setValue(1);
      this.alertvarservice.alertpagelength = 1;
      this.alertvarservice.filter_changes_state = true
      if (this.alertvarservice.filter_changes_state) {
        let postValue: any = this.alertvarservice.alertFilters.value;
        // console.log("TimeRange",postValue.external.timerange)
        // console.log("NEWTIMERANGE",this.alertvarservice.chips[0].time.value)
        // postValue.external.timerange = this.toDate(postValue.external.timerange);
        postValue.external.timerange = this.toDate(this.alertvarservice.chips[0].time.value);
        //console.log(this.alertvarservice.chips[1].platform.value,"Platform")
        postValue.external.platform = this.alertvarservice.chips[1].platform.value
        //console.log("Tags-2",this.post_tags)
        postValue.external.tags = this.post_tags
        //console.log("Tags-3",this.post_tags)
        postValue.external.severity = this.post_severity
        Object.assign(postValue.external, { status: this.post_status, title: this.post_title, data_type: this.post_dataType, observable: this.post_observable, signature: this.post_signature })
        // postValue.external.severity=this.alertvarservice.chips[2].severity.value

        this.alertvarservice.advanced_filter_values = this.alertvarservice.get_events_timerange()

        // console.log("Check Tags",this.structureTagsService.structureTagPost(postValue.external.tags))

        // postValue.external.tags = this.structureTagsService.structureTagPost(postValue.external.tags);

        //console.log("AlertRows",this.alertvarservice.alertRows.length)

        //console.log("PostValue: ",postValue,"AdvancedFilters: ",this.alertvarservice.advanced_filter_values)

        this.alertvarservice.alertRows.length = 0;
        this.requestAlertSummarydata(this.processFilterPost(postValue));
      } else if (this.alertvarservice.alertSummaryData.alertRows.length) {
        this.spinner_alert_list_state = true;
        this.provideInternalFilter(this.alertvarservice.alertSummaryData.alertRows, this.internal.value);
        this.handlePagination(this.alertvarservice.alertRows.length, this.itemPerPage.value);
        this.spinner_alert_list_state = false;
      }
      this.alertvarservice.filter_changes_state = false;

      let filterpost = {}
      // console.log("-->",this.toDate(this.alertvarservice.chips[0].time.value))
      filterpost["timerange"] = this.toDate(this.alertvarservice.chips[0].time.value);
      filterpost["platform"] = this.alertvarservice.chips[1].platform.value
      filterpost["tags"] = this.post_tags
      filterpost["severity"] = this.post_severity
      Object.assign(filterpost, { status: this.post_status, title: this.post_title, data_type: this.post_dataType, observable: this.post_observable, signature: this.post_signature })

      //console.log("Tags-1",this.post_tags)
      this.alertvarservice.payload = filterpost
      this.spinner_alert_filter_state = true;
      //console.log(this.spinner_alert_filter_state)
      this.alertservice.getAlertFilter(filterpost).subscribe((val) => {
        //console.log("Filter Data on Filter Click",val)
        this.alertFilter = val
        // this.alertFilter=this.mockFilter

        this.spinner_alert_filter_state = false;
        //console.log(this.spinner_alert_filter_state)
      },(err)=>{
        this.spinner_alert_filter_state = false;
      })
      // this.alertFilter=this.alertservice.getAlertFilter()




    } else {
      this.alertservice.providealertdata.cancelRequest();
      this.alertvarservice.filter_changes_state = true;
    }
  }

  refreshAlertTables() {
    if (!this.inProgress) {
      this.alertvarservice.filter_changes_state = true;
      this.applyFilter_click();
    }
  }

  resetFilterResult() {
    //console.log(">>>>>>>>>>>>>>>",this.alertMetaData.filterOptions.timeRanges)
    if (!this.inProgress) {
      this.alertvarservice.alertFilters.reset(this.alertMetaData.alertDefaults);
      this.alertvarservice.gethost();
      this.alertvarservice.filter_changes_state = true;
      this.spinner_alert_list_state = true;
      this.alertvarservice.alertRows.length = 0;
      this.requestAlertonInit();
    }
  }

  arrayToString(data: any): string {
    const map: Record<string, string[]> = {};
  
    data.forEach(obj => {
      const oldKey = Object.keys(obj)[0];
      const disp = obj[oldKey].disp;

      const key = oldKey === "title" ? "alert name" : oldKey;
  
      if (!map[key]) {
        map[key] = [];
      }
  
      map[key].push(disp);
    });
  
    return Object.entries(map)
      .map(([key, values]) => `${key.toUpperCase()}:${values.join(", ")}`)
      .join("\n");
  }

  //download alertSummaryData in pdf
  downloadAlertpdf_click() {
    if (!this.inProgress) {
      let headers: any = [];
      for (const val of this.alertMetaData.alertTableHeaders) {
        headers.push(val.disp)
      }
//console.log(this.alertvarservice.chips)
      
      // console.log(this.alertvarservice.alertSummaryData.alertRows)
      // headers[0] = this.alertMetaData.filterlabels[0]
      // console.log({headers})
      let filterhead=[]
      this.alertvarservice.chips.forEach(data=>{
        // console.log(Object.keys(data)[0])
        // if(Object.keys(data)[0] === 'title'){
        //   filterhead.push('AlertName')
        // }else{
        filterhead.push(Object.keys(data)[0])
        // }
      })
      // console.log({filterhead})
      let filterRow=[]


     
      // const filterrows=this.alertvarservice.chips.map(dat=>{
      //   let rowsArr =[]
      //   filterhead.forEach(data=>{
      //     console.log({data})
      //     console.log("dat->",dat)
      //     console.log(dat[data])
      //     // filterhead.push(data)
      //     rowsArr.push(dat)
      //   })
      //   console.log({rowsArr})
      //   return rowsArr;

      // })
      const rows = this.alertvarservice.alertSummaryData.alertRows.map((dat: any) => {
        let rowsArr = []
        for (const valu of this.alertMetaData.alertTableHeaders) {
          if (valu.val == 'lastAlertTime') {
            rowsArr.push(this.epochtodate(dat[valu.val]))
          } else {
            rowsArr.push(dat[valu.val])
          }
        }
        // console.log({rowsArr})
        return rowsArr;
      });
      let updateY:number=1
     
      const doc = new jsPDF('landscape', 'px', 'a3') as jsPDFWithPlugin;

      doc.addFileToVFS('Metropolis-ExtraLight.ttf', Metropolis_ExtraLight);
      doc.addFileToVFS('Metropolis-Light.ttf', Metropolis_Light);
      doc.addFileToVFS('Metropolis-LightItalic.ttf', Metropolis_LightItalic);
      doc.addFileToVFS('Metropolis-Medium.ttf', Metropolis_Medium);
      doc.addFileToVFS('Metropolis-Regular.ttf', Metropolis_Regular);
      doc.addFileToVFS('Metropolis-SemiBold.ttf', Metropolis_SemiBold);
      doc.addFont('Metropolis-Regular.ttf', 'metropolis', 'normal');
      doc.addFont('Metropolis-Light.ttf', 'metropolis', 'light');
      doc.addFont('Metropolis-SemiBold.ttf', 'metropolis', 'bold');

      const fileName = "Alerts_"+this.timezoneservice.getcurrentuserTime().format("DDMMYYYY")+".pdf"
      let string=""
      string=this.arrayToString(this.alertvarservice.chips)
      let date="DATE : "+this.timezoneservice.getcurrentuserTime().format("DD-MM-YYYY")+"\n"+"TIME : "+this.timezoneservice.getcurrentuserTime().format("hh:mm:ss")
      let prev=''
      this.alertvarservice.chips.forEach((key,i)=>{
        // console.log({i})
        // filterRow.push(key.value)
        Object.keys(key).forEach((val,index)=>{
          // console.log("val->",key[val].disp)
//console.log(val,"->",prev)
          if(val != prev){
            // let num=1
            updateY+=1.5
//console.log({updateY})
          }
          prev = val
          
          filterRow.push(key[val].disp)
          if(val === 'title'){
            // string+="ALERT NAME : "+key[val].disp+" \n "
          }else{
            // string+=val.toUpperCase()+" : "+key[val].disp+" \n "
          }
          // updateY=i+1
        })
        // console.log("key->",key)
        
       })

       let title="FILTERS :"

      //  doc.setFillColor('#f1f6f8');

       
      //   doc.rect(
      //     0,
      //     0,
      //     doc.internal.pageSize.getWidth(),
      //     doc.internal.pageSize.getHeight(),
      //     'F'
      //   );

      // let max=600
      // let indent=50
      // const lines = doc.splitTextToSize(string, max);
       

       let y= 30
       doc.setFontSize(8)
       doc.setTextColor('#0A4143')
       doc.setFont('metropolis','bold')
       doc.text(title,30,y-12)
       doc.setFontSize(8)
       doc.setTextColor("#0A4143")
       doc.setFont('metropolis','normal')
       doc.text(string,35,y,{
        maxWidth:700
       })
      // doc.text(lines[0],35,y)
      // lines.slice(1).forEach((line, index) => {
      //   doc.text(line, 20 + indent, 40 + (index + 1) * 6);
      // });
       doc.text(date,800,y)
      //  console.log({y})
      //  console.log({updateY})
       y+=updateY*8
      //  console.log({y})

      

      // console.log({filterhead})
      // console.log({filterRow})

      // doc.autoTable({
      //   head: [filterhead],
      //   body: [filterRow],
      //   headStyles: {
      //     fillColor: "white",
      //     fontSize: 13,
      //     textColor: "#0A4143"
      //   },
      //   styles: {
      //     fontSize: 12,
      //     cellWidth: "auto",
      //     textColor: "gray",
      //     lineWidth: 1
      //   },
      //   alternateRowStyles: {
      //     fillColor: "white"
      //   }
      // })

     
      
      doc.autoTable({
        head: [headers],
        body: rows,
        startY:y,
        
        headStyles: {
          font: 'metropolis',
          // fillColor: "white",
          fillColor:"#f1f6f8",
          fontSize: 8,
          // textColor: "#0A4143"
          textColor:"#48454a",
          minCellWidth:5
        },
        styles: {
          font: 'metropolis',
          // cellPadding:2,
          cellPadding:{
            "top":4,
            "bottom":4
          },
          fontSize: 8,
          cellWidth: "auto",
          // textColor: "gray",
          textColor:"#48454a",
          // lineWidth: 1
          // lineWidth: 0.2,
          // lineColor: [0, 0, 0]
        },
        alternateRowStyles: {
          fillColor: "white"
        },
        didDrawCell(data) {
          const { cell, row, table } = data;
      
          // if (data.section === 'body') {
            const x = cell.x;
            const y = cell.y + cell.height;
            const width = cell.width;
      
            doc.setLineWidth(1);
            doc.line(x, y, x + width, y);
          // }
        },
        
        // tableLineWidth: 0.2,
        // tableLineColor: [0, 0, 0]
      });
      // console.log({doc})
      doc.save(fileName);
    }
  }

  // processrelativetime(time: any) {
  //   const currentusertime = this.timezoneservice.getcurrentuserTime();
  //   if (time[1] == "hour") {
  //     const start_date = currentusertime.clone().subtract(time[2], 'hour');
  //     return [start_date.format('YYYY-MM-DD HH:mm:ss'), currentusertime.format('YYYY-MM-DD HH:mm:ss')];
  //   } else if (time[1] == "today") {
  //     const start_date = currentusertime.clone();
  //     return [start_date.set({ 'hour': 0, 'minute': 0, 'second': 0 }).format('YYYY-MM-DD HH:mm:ss'), currentusertime.format('YYYY-MM-DD HH:mm:ss')];
  //   } else if (time[1] == "yesterday") {
  //     const start_date = currentusertime.clone().subtract(1, 'days');
  //     return [start_date.set({ 'hour': 0, 'minute': 0, 'second': 0 }).format('YYYY-MM-DD HH:mm:ss'), start_date.endOf('day').format('YYYY-MM-DD HH:mm:ss')];
  //   } else {
  //     const previousdate = currentusertime.clone().subtract(time[2], 'days');
  //     return [previousdate.set({ 'hour': 0, 'minute': 0, 'second': 0 }).format('YYYY-MM-DD HH:mm:ss'), currentusertime.format('YYYY-MM-DD HH:mm:ss')];
  //   }
  // }
  //calacute date for timerange option
  toDate(metaDate: any) {
    // console.log({metaDate})
    let date=[this.timezoneservice.toUtcTimeZonefromUser(this.alertvarservice.calculate_timerange(metaDate)[0]).format('YYYY-MM-DD HH:mm:ss'),this.timezoneservice.toUtcTimeZonefromUser(this.alertvarservice.calculate_timerange(metaDate)[1]).format('YYYY-MM-DD HH:mm:ss')]
    return date
    // return this.alertvarservice.calculate_timerange(metaDate)
    // return this.processrelativetime(metaDate)
    // const utcstr = moment().utc();
    // const last = utcstr.clone().subtract(metaDate[1], 'days');
    // return [last.startOf('day').format('YYYY-MM-DD HH:mm:ss'), utcstr.format('YYYY-MM-DD HH:mm:ss')];
  }

  epochtodate(utcSeconds: number) {
    const myDate = new Date(utcSeconds * 1000);
    return myDate.getDate() + "/" + (myDate.getMonth() + 1) + "/" + myDate.getFullYear() + " " + myDate.getHours() + ":" + myDate.getMinutes() + ":" + myDate.getSeconds()
  }

  //impacted host menu open
  openHostMenu_click(template: any, origin: any) {
    let config = {
      data: {
        "template": template,
      }
    }
    this.cdkoverlayDialog.openMenu(config, TemplateDropdownComponent, origin);
  }
  force_continue_alert(user_already_review: string, lattest_time: string, row: any) {
    const termiateSessionDialogRef = this.matdialog.open(ForceContinueComponent, {
      width: "25vw", height: "24vh", data: { user_already_review, lattest_time }, autoFocus: false,
      disableClose: true
    })
    termiateSessionDialogRef.afterClosed().subscribe((confirm) => {
      if (confirm) {
        this.force_view = true;
        this.openFactsheet_click(row)
      } else {

      }
    })

  }
  //mat-dialog open
  openFactsheet_click(row: any) {

    this.alertservice.lockAlert(row.alertId, this.force_view)
      .then(val => {


        this.alertvarservice.alertscollapsedata.alertRowsData = [...this.alertvarservice.alertSummaryData.alertRows];
        this.alertvarservice.alertscollapsedata.selectedrows.next(row);
        this.alertvarservice.alertscollapsedata.selectedalert = row;
        this.alertvarservice.factSheetOpened = true;
        this.alertvarservice.summaryPanel = FactsheetSummaryPanel.collapse;
        this.alertvarservice.eventsPanel = FactsheetEventsPanel.collapse;
        this.alertvarservice.advancefilter_pannelexpanded = false;
        this.alertvarservice.alertEventSelectedIndex = 0;
        this.alertservice.getAlertsFields({ alertId: row.alertId, platform: row.platform })
          .subscribe((data: any) => {
            this.alertvarservice.eventFieldOptions = this.alertvarservice.processplatformFields(data.platform_fields);
            // this.alertvarservice.
            // console.log("getAlertsFields=========== api return result  ", data, this.alertvarservice.eventFieldOptions)
          })
      })
      .catch((err) => {
        // console.log('err==');
        this.force_view = false;
        this.force_continue_alert(err.user_already_review, err.lattest_time, row);
      })

  }



  getalerterror() {
    return this.handleprovidealertdataerror.isError()
  }

  opencreate() {
    // this.router.navigateByUrl('/auto-closure-rule')
    this.router.navigateByUrl('explorelogs/alerts/auto-closure-rule')
  }
  openAutoInvestigate() {
    //console.log("Auto Investigate")
    this.router.navigateByUrl('explorelogs/alerts/auto-investigate-rule')
  }
  openConsolidation() {
    this.router.navigateByUrl('explorelogs/alerts/consolidation-rule')
  }
  openDirectToSignal() {
    this.router.navigateByUrl('explorelogs/alerts/direct-to-signal')
  }




  clickcreate(type, alert) {
    // this.router.navigateByUrl("rule/create")
    //console.log("Alert>>>>>>>>>>>>",alert.alertTitle)
    // this.alertvarservice.ruleName=alert.alertTitle
//console.log({ alert })
//console.log(this.alertvarservice.ruleCOnditions.conditions)
    // this.alertvarservice.setAlert({ ...alert, ...{ conditions: this.alertvarservice.ruleCOnditions.conditions } })  
    this.alertvarservice.setPlatform(alert.platform)
    this.alertvarservice.setRuleType(type.value);
    this.alertvarservice.setAlertTitle(alert.alertId);
    this.sharedService.setAlertTitle(alert.alertId);
    this.createrule.close()
    if (type.value === "auto_closure") {
      this.alertvarservice.setAlert({ ...alert, ...{ conditions: this.alertvarservice.autoClosureRuleCondition.conditions } })
      this.opencreate()
    }
    else if (type.value === "auto_investigate") {
      this.alertvarservice.setAlert({ ...alert, ...{ conditions: this.alertvarservice.ruleCOnditions.conditions } })
      this.openAutoInvestigate()
    }
    else if (type.value === "consolidation") {
      this.openConsolidation()
    }
    else if (type.value === "direct_to_signal") {
      this.alertvarservice.setAlert({ ...alert, ...{ conditions: this.alertvarservice.autoClosureRuleCondition.conditions } })
      this.openDirectToSignal()
    }
  }
  openSourceMenu_click(template: any, origin: any,event) {
    // event.stopPropagation()
    let config = {
      width: "auto",
      height: "auto",
      data: {
        "template": template,
      }
    }
    // this.cdkverlayDialog.openMenu(config, TemplateDropdownComponent, origin);
    this.createrule = this.cdkverlayDialog.openPreview(config, TemplateDropdownComponent, origin);
  }

  //Store the selected Filter options in an array
  optionClick(key: string, option: any) {
    //console.log("Chips in optionClick",this.alertvarservice.chips)
    //console.log("Options>>>>>>>>>",key,":",option)
    // console.log(this.alertFilter[key].multi_select)
    if (this.alertFilter.filters[key].mandatory) {
      option.mandatory = true
    }
    let obj = { [key]: option }

    if (!this.alertFilter.filters[key].multi_select) {
      let existingKey = this.alertvarservice.chips.findIndex(chip => chip.hasOwnProperty(key));
      if (existingKey !== -1) {
        this.alertvarservice.chips[existingKey] = obj;
      } else {
        this.alertvarservice.chips.push(obj);
      }
    }
    else {
      // console.log("Chip[key]----->",this.alertvarservice.chips)
      //console.log("Option------->",option)
      // let existingIndex = this.alertvarservice.chips.findIndex(chip => chip[key] === option);
      let existingIndex = this.alertvarservice.chips.findIndex(chip => chip.hasOwnProperty(key) && chip[key]['disp'] === option['disp'] && chip[key]['value'] === option['value']);
      //console.log("key--->",existingIndex)
      //console.log("Chip[key]----->",this.alertvarservice.chips[existingIndex])
      if (existingIndex !== -1) {
        // this.alertvarservice.chips[existingIndex] = obj;
        //console.log("EXISTS")
      } else {
        this.alertvarservice.chips.push(obj);
      }
    }
    //console.log("Chips>>>>>>>>",this.alertvarservice.chips)
    this.calculateChips();
  }

  checkChips(key: any, list: any) {
    // console.log(key ,list)
    // console.log(this.alertvarservice.chips)
    let existingIndex = this.alertvarservice.chips.findIndex(chip => chip.hasOwnProperty(key) && chip[key]['disp'] === list['disp']);
    // console.log("Existing",this.alertvarservice.chips[existingIndex])
    if (this.alertvarservice.chips[existingIndex]) {
      return true
    }
    else {
      return false
    }
    // return false
  }
  //Remove chips
  removeChip(chip: any) {
    //console.log(this.alertvarservice.chips)
    const key = Object.keys(chip)[0];
    const value = chip[key];
    if (!value.mandatory) {
      this.alertvarservice.chips = this.alertvarservice.chips.filter(item => item[key] !== value);
      this.calculateChips()
    }
    //console.log("AfterRemoved",this.alertvarservice.chips)
  }
  removeMoreChip(chip: any) {
    //console.log(this.alertvarservice.chips)
    const key = Object.keys(chip)[0];
    const value = chip[key];
    this.alertvarservice.chips = this.alertvarservice.chips.filter(item => item[key] !== value);
    this.morechips = this.morechips.filter(item => item[key] !== value);
    this.calculateChips()
    //console.log("AfterRemoved",this.alertvarservice.chips)
  }
  //clear all chips
  clearFilter() {
    this.alertvarservice.chips = this.alertvarservice.chips.filter(item => {
      const key = Object.keys(item)[0];
      return (item as any)[key].mandatory === true;
    });
    this.calculateChips()
    this.applyFilter_click()

  }
  // Scroll chips when arr0w is clicked
  moveplatformlist(direction: number) {
    this.chipList.nativeElement.scrollTo({ left: direction * (this.chipList.nativeElement.scrollLeft + 100), behavior: 'smooth' });
  }

  moreChips() {
    this.morechips = this.alertvarservice.chips.slice(11)
    //console.log(this.morechips) 
  }
  moreItem() {
    this.limitCount = this.limitCount + 100
  }


  // calculateChips() {
  //   const chips = this.alertvarservice.chips;
  
  //   this.visibleChips = [...chips];
  //   this.morechipslist = [];
  
  //   setTimeout(() => {
      
  //     const container = this.chipList.nativeElement;
  //     const containerWidth = container.clientWidth;
  
  //     const chipElements =
  //       this.chipElements.toArray();
  
  //     let usedWidth = 0;
  //     let visibleCount = 0;
  
  //     for (let i = 0; i < chipElements.length; i++) {
  
  //       const element = chipElements[i].nativeElement;
  
  //       const style = getComputedStyle(element);
  
  //       const margin =
  //         parseFloat(style.marginLeft) +
  //         parseFloat(style.marginRight);
  
  //       const chipWidth =
  //         element.getBoundingClientRect().width + margin;
  
  //       // Reserve some space for "+N more"
  //       const moreButtonWidth = 80;

  //       console.log(usedWidth,"+",chipWidth,"+",moreButtonWidth,"==",containerWidth)
  
  //       if (
  //         usedWidth + chipWidth + moreButtonWidth <=
  //         containerWidth*1.8
  //       ) {
  //         usedWidth += chipWidth;
  //         visibleCount++;
  //       } else {
  //         break;
  //       }
  //     }

  //     console.log("Visible count -> ",visibleCount)
  
  //     this.visibleChips =
  //       chips.slice(0, visibleCount);
  
  //     this.morechipslist =
  //       chips.slice(visibleCount);
  //       console.log("Visible =-> ",this.visibleChips)
  //       console.log("More =-> ", this.morechipslist)
  //   });
    
  // }
  calculateChips() {

    const chips = this.alertvarservice.chips;
  
    if (!chips?.length) {
      this.visibleChips = [];
      this.morechipslist = [];
      return;
    }
  
    const defaultChips = chips.slice(0, 2);
    const remainingChips = chips.slice(2);
  
    setTimeout(() => {
  
      const containerWidth =
        this.chipList.nativeElement.clientWidth;
  
      const chipElements =
        this.chipMeasure.nativeElement
          .querySelectorAll('.chip-item');
  
      let usedWidth = 0;
      let visibleCount = 0;
  
      const moreButtonWidth = 80;
  
      // First reserve width for the 2 default chips
      for (let i = 0; i < 2; i++) {
  
        const element =
          chipElements[i] as HTMLElement;
  
        if (!element) {
          continue;
        }
  
        const style =
          getComputedStyle(element);
  
        const margin =
          parseFloat(style.marginLeft || '0') +
          parseFloat(style.marginRight || '0');
  
        const width =
          element.getBoundingClientRect().width +
          margin;
  
        usedWidth += width;
      }
  
      // Now calculate how many non-default chips fit
      for (let i = 2; i < chipElements.length; i++) {
  
        const element =
          chipElements[i] as HTMLElement;
  
        const style =
          getComputedStyle(element);
  
        const margin =
          parseFloat(style.marginLeft || '0') +
          parseFloat(style.marginRight || '0');
  
        const chipWidth =
          element.getBoundingClientRect().width +
          margin;

// console.log(usedWidth,"+",chipWidth,"+",moreButtonWidth,"==",containerWidth)
  
        if (
          usedWidth +
          chipWidth +
          moreButtonWidth <=
          containerWidth*1.9
        ) {
  
          usedWidth += chipWidth;
          visibleCount++;
  
        } else {
          break;
        }
      }
  
      // Always include the first 2
      this.visibleChips =
        chips.slice(0, visibleCount + 2);
  
      // Everything after those goes to More
      this.morechipslist =
        chips.slice(visibleCount + 2);

// console.log("Visible =-> ",this.visibleChips)
// console.log("More =-> ", this.morechipslist)
  
    });
  
  }

  openEditPopup(template,alertId,status) {
    // this.alertvarservice.dedupId = alertId
    this.alertvarservice.dedupData.alertId=alertId
    this.alertvarservice.dedupData.status=status
    const dialogRef: MatDialogRef<any> = this.matdialog.open(template, {
      minWidth: '40vw',  
      minHeight: '17vh',
      maxWidth: '100%',
      maxHeight: '100%',
      width:'98%',
      height:'97%',
      // disableClose:true
      // panelClass: 'resizable-dialog'
    });

    this.dialogRef = dialogRef

    this.alertvarservice.dedupDialogRef = dialogRef

    this.dialogRef._afterClosed.subscribe(val=>{
      // this.alertvarservice.dedupId = ""
      this.alertvarservice.dedupData = {"alertId":"","status":0}
      console.log("Close")
    })

    console.log(this.dialogRef)
  }




  


  ngOnDestroy(): void {
    //console.log("<-------------Summary Table Destroyed-------------->")
    if (this.alertservice.checklogged()) {
      this.alertservice.alertsummarycomponentDestroyed.next(0);
    }
    this.$destroy.next()
    this.$destroy.unsubscribe()
  }
}